import * as React from "react";

import './Spinner.scss'

interface Props {
  height?: number;
  width?: number;
  fill?: string;
  style?: any;
}

const Spinner = ({
  height = 800,
  width = 800,
  fill = '#000000',
  style,
  ...props
}: Props) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      animation: 'spin 1s linear infinite',
      ...style,
    }}
    {...props}
  >
    <g>
      <path d="M8,1V2.8A5.2,5.2,0,1,1,2.8,8H1A7,7,0,1,0,8,1Z" />
    </g>
  </svg>
);

export default Spinner;